const baseStyle = {};
const defaultProps = {
    variant: 'subtleBlue'
};
const parts = ['container', 'button', 'icon', 'text', 'title'];
const sizes = {};
const variants = {
    subtleBlue: {
        container: {
            bg: 'skyBlue.95',
            borderColor: 'seaBlue.main',
            color: 'seaBlue.main'
        },
        button: {
            borderColor: 'transparent'
        }
    },
    subtleRed: {
        container: {
            bg: 'energyRed.95',
            borderColor: 'energyRed.45',
            color: 'energyRed.45'
        }
    },
    subtleYellow: {
        container: {
            bg: 'sunflower.85',
            borderColor: 'sunflower.15',
            color: 'sunflower.15'
        }
    },
    subtleGreen: {
        container: {
            bg: 'landGreen.95',
            borderColor: 'landGreen.30',
            color: 'landGreen.30'
        }
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
